'use strict';

module.exports = [
  require('iso-8859-15'),
  require('iso-8859-2'),
  require('iso-8859-3'),
  require('iso-8859-4'),
  require('iso-8859-5'),
  require('iso-8859-6'),
  require('iso-8859-7'),
  require('iso-8859-8'),
  require('iso-8859-8-i'),
  require('koi8-r'),
  require('macintosh'),
  require('windows-1250'),
  require('windows-1251'),
  require('windows-1252'),
  require('windows-1253'),
  require('windows-1254'),
  require('windows-1255'),
  require('windows-1256'),
  require('windows-1257'),
  require('windows-1258'),
  require('windows-874'),
  require('x-mac-cyrillic')
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-encoding/encodings.js
// module id = 144
// module chunks = 0